module.exports = __webpack_public_path__ + "assets/addReviewComment.6ea79f28.svg";